module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.fee66e7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fa/fontawesome-webfont.woff
// module id = 694
// module chunks = 1